import axios, { AxiosError, CancelTokenSource } from 'axios';
import { ApiUrls } from '../constants/apiUrls'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { IApiResponse } from '../models/ApiResponseModels'
import { ServiceObjectTypeNumber, ServiceObjectTypeAttachAccount } from "../models/SettingModels"

export class SettingRequests {
    private cancelTokenSource?: CancelTokenSource


    public Init(): void {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    public Abort(): void {
        this.cancelTokenSource?.cancel();

    }


    public async GetServiceObjectTypeNumber(): Promise<IApiResponse<ServiceObjectTypeNumber | null>> {
        return await axios.get<IApiResponse<ServiceObjectTypeNumber | null>>(`${ApiUrls.GetServiceObjectTypeNumber}`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async GetServiceObjectTypeAttachAccount(): Promise<IApiResponse<ServiceObjectTypeAttachAccount | null>> {
        return await axios.get<IApiResponse<ServiceObjectTypeAttachAccount | null>>(`${ApiUrls.GetServiceObjectTypeAttachAccount}`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }



}